import { useMemo, useState } from 'react';
import { Autoplay } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import Icon from '@/components/atoms/icon/icon';
import MediaLightbox from '@/components/molecules/media-lightbox/media-lightbox';
import MediaSliderControls from './media-slider-controls/media-slider-controls';
import MediaSlideItem, {
  MediaSliderItemProps,
} from './media-slider-item/media-slider-item';
import styles from './media-slider.module.scss';

export interface MediaSliderProps {
  /** The items to display in the grid */
  items: MediaSliderItemProps[];
  /** Indicates whether the image should be loaded immediately */
  priority?: boolean;
}

const SWIPER_CONFIGURATION = {
  autoplay: { delay: 5000 },
  modules: [Autoplay],
  slidesPerGroup: 1,
  slidesPerView: 1,
  speed: 500,
};

const MediaSlider = ({ items = [], priority = false }: MediaSliderProps) => {
  const [activeImageIndex, setActiveImageIndex] = useState<number>(-1);
  const lightboxItems = useMemo(() => {
    return items.map(item => ({
      media: item,
    }));
  }, [items]);

  return (
    <div className={styles.component}>
      <Swiper
        {...SWIPER_CONFIGURATION}
        className={styles.swiper}
        loop={items.length > 1}
        wrapperClass={styles.swiperWrapper}
      >
        {items.map((item, itemIndex) => (
          <SwiperSlide
            key={item.id}
            className={styles.slide}
            onClick={() => {
              setActiveImageIndex(itemIndex);
            }}
          >
            <MediaSlideItem
              {...item}
              aspectRatio="oneByOne"
              priority={itemIndex === 0 && priority}
            />
          </SwiperSlide>
        ))}

        <Icon className={styles.zoomIcon} name="Expand" size={24} />

        <MediaSliderControls />
      </Swiper>

      <MediaLightbox
        isOpen={activeImageIndex !== -1}
        items={lightboxItems}
        onClose={() => setActiveImageIndex(-1)}
        startIndex={activeImageIndex}
      />
    </div>
  );
};

MediaSlider.displayName = 'MediaSlider';

export default MediaSlider;
